import request from '../request';
import { getSystemSettings, getSessionId } from '../SettingsRetriever';
import SalesIDRetriever from '../SalesIDRetriever';

import moment from 'moment';

import { addBundle as globalAddBundle } from "../../services/cart";

const compareBundleFunction = (a, b) => {
    let customOrder = undefined;

    if (getSystemSettings() && getSystemSettings().app && getSystemSettings().app.bundles && getSystemSettings().app.bundles.productOrder){
        customOrder = getSystemSettings().app.bundles.productOrder;
    }

    if (customOrder){
        return a[customOrder] < b[customOrder] ? -1 : 1;
    } else {
        return a.itemProductId - b.itemProductId;
    }
}

export function getBundle (upsellItemList) {
    return new Promise((resolve, reject) => {
        request({
            url: getSystemSettings().api + '/inntopia/cart/bundle',
            method: 'POST',
            data: {
                sessionId: getSessionId(),
                itineraryItemList: upsellItemList.ParentItineraryItemId ? upsellItemList.ParentItineraryItemId : upsellItemList,
                salesId: SalesIDRetriever(),
                productBundleId: upsellItemList.BundleId ? upsellItemList.BundleId : null
            }
        })
        .then(response =>{
            let bundleObject = {
                bundles: [],
                bundleModal : [],
                currentIndexModal: 0,
                productNameBundle: [],
                incorrectAmount: false
            }

            if(response.data.length === 0 || response.status === 206){
                resolve(false);
            }

            let amountOfBundles = 0;
            let amountOfEmptyBundles = 0;
            response.data.forEach((itineraryItem, idx) => {
                itineraryItem.Bundles.forEach((bundle) => {
                    amountOfBundles++
                    if (bundle.childProducts.length > 0){
                        bundle.childProducts.sort((a, b) => compareBundleFunction(a, b))
                        if (!bundle.childProducts.find(product => product.QuantitySelected >= 1)){
                            bundle.childProducts[0].QuantitySelected = bundle.minAddOn > 0 ? bundle.minAddOn : 1;
                        }
                        bundle.ArrivalDate = moment.utc(itineraryItem.SearchData.ArrivalDate).format("YYYY-MM-DD")
                        bundle.DepartureDate = moment.utc(itineraryItem.SearchData.DepartureDate).format("YYYY-MM-DD")
                        bundle.productNameBundle = itineraryItem.ProductName;
                        bundleObject.bundles.push(bundle)
                        bundleObject.bundleModal.length === 0 ? bundleObject.bundleModal.push(true) : bundleObject.bundleModal.push(false)
                    } else {
                        amountOfEmptyBundles++
                    }
                })
            })
            if (amountOfBundles === amountOfEmptyBundles){
                resolve(false)
            } else {
                resolve(bundleObject);
            }
        }).catch(err => reject(err));
    })

}

 export function updateBundleAmount (value, bundleObject, productIndex) {
    let currentAmount = 0
    bundleObject.bundles[bundleObject.currentIndexModal].childProducts.forEach((product, index) => {
        if (index !== productIndex){
            currentAmount += product.QuantitySelected
        }
    })
    if (currentAmount + value <= bundleObject.bundles[bundleObject.currentIndexModal].maxAddOn){
        bundleObject.bundles[bundleObject.currentIndexModal].childProducts[productIndex].QuantitySelected = value
        bundleObject.incorrectAmount = false
    } else {
        bundleObject.bundles[bundleObject.currentIndexModal].childProducts.forEach((product, index) => {
            product.QuantitySelected = 0;
        })
        bundleObject.bundles[bundleObject.currentIndexModal].childProducts[productIndex].QuantitySelected = value
        bundleObject.incorrectAmount = false
    }
    return bundleObject
}

export function toggleBundleModal (bundleObject, value) {
    bundleObject.bundleModal[bundleObject.currentIndexModal] = value;
    if (bundleObject.bundleModal.length > (bundleObject.currentIndexModal + 1)){
        bundleObject.bundleModal[bundleObject.currentIndexModal + 1] = true;
        bundleObject.currentIndexModal++;
    } else {
        bundleObject.bundleModal = [];
        bundleObject.bundles = [];
        bundleObject.currentIndexModal = 0;
    }
    return bundleObject;
}

export function addBundleProducts (bundle, callback) {
    let element = {
        parentItemId: bundle.itineraryItemId,
        productBundleId: bundle.productBundleId,
        items: []
    }
    let addedIsEmpty = true;
    bundle.childProducts.forEach((product) => {
        let item = {};
        if (product.QuantitySelected > 0){
            item.SupplierId = product.ItemSupplierId || product.itemSupplierId;
            item.ProductId = product.ItemProductId || product.itemProductId;
            item.ArrivalDate = bundle.ArrivalDate;
            item.DepartureDate = bundle.ArrivalDate;
            item.PackageId = null;
            item.PackageComponentId = null;
            item.AdultCount = 1;
            item.ChildCount = 0;
            item.Quantity = product.QuantitySelected;
            item.ParentItemId = bundle.itineraryItemId;
            item.ProductBundleId = bundle.productBundleId;
            element.items.push(item);
            addedIsEmpty = false;
        }
    })
    if (addedIsEmpty){
        callback(false);
    } else {
        callback(element)
    }
}


export function addBundleToCart(element){
    return globalAddBundle({
        itineraryitems: JSON.stringify(element.items),
        itineraryItemId: element.parentItemId,
        productBundleId: element.productBundleId,
        productWithFullInfo: element.items
    })
}